"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.76,0H2.24a.56.56,0,0,0-.63.64V20.15a.56.56,0,0,0,.63.64H8.63l3.21,3.15a.24.24,0,0,0,.32,0l3.21-3.15h6.39a.56.56,0,0,0,.63-.64V.64A.56.56,0,0,0,21.76,0Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.23,14.07l2.17-6.5a.35.35,0,0,0-.34-.47H7.28L6.32,3A.36.36,0,0,0,6,2.76H3.44a.36.36,0,0,0,0,.72H5.68L8.42,15.12a1.44,1.44,0,0,0,.44,2.81,1.43,1.43,0,0,0,1.24-2.16h5.46A1.44,1.44,0,1,0,16.81,15H9.15L9,14.32h8.91A.35.35,0,0,0,18.23,14.07Zm-7.16-.83H11a.38.38,0,0,1-.37-.31L9.88,9a.39.39,0,0,1,.3-.44.38.38,0,0,1,.44.3l.75,3.9A.38.38,0,0,1,11.07,13.24Zm3-.53a.37.37,0,0,1-.37.38h0a.38.38,0,0,1-.38-.38V9.13a.38.38,0,0,1,.38-.37h0a.37.37,0,0,1,.37.37Zm2.49.23a.38.38,0,0,1-.37.31h-.07a.37.37,0,0,1-.3-.44l.75-3.9A.38.38,0,0,1,17,8.6a.39.39,0,0,1,.3.44Z",
    style: {
      fill: '#fff'
    }
  }));
};

exports["default"] = _default;